<template>
    <div data-test-id="bottom-color-mode-picker" class="inline-flex shrink-0 print:hidden">
        <CDarkModeToggle show-label />
    </div>
</template>
